export default "__VITE_ASSET__BVTCQLyB__"